import { faEnvelope, faHome, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import './Header.scss'
import LogoS from '../../assets/images/Logo-a.png'
import LogoSubtitle from '../../assets/images/logo_sub.png'
const Header = () => {
    return (
        <div className='nav-bar sticky-top'>
            <Navbar collapseOnSelect expand="lg" bg="black" variant="dark">
                <Container>
                    <Link className='logo' to='/'>
                        <img src={LogoS} alt="logo" />
                        <img className='sub-logo' src={LogoSubtitle} alt="Arefin " />
                    </Link>

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ms-auto gap-5">

                            <Nav.Link>
                                <NavLink exact="true" activeclassname="active" className="home-link position-absolute top-50 start-50 translate-middle" to="/">
                                    <FontAwesomeIcon icon={faHome} color="#4d4d4e"></FontAwesomeIcon>
                                </NavLink>

                            </Nav.Link>

                            <Nav.Link>
                                <NavLink exact="true" activeclassname="active" className="about-link position-absolute top-50 start-50 translate-middle" to="/about">
                                    <FontAwesomeIcon icon={faUser} color="#4d4d4e"></FontAwesomeIcon>
                                </NavLink>
                            </Nav.Link>

                            <Nav.Link>
                                <NavLink exact="true" activeclassname="active" className="contact-link position-absolute top-50 start-50 translate-middle" to="/contact">
                                    <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e"></FontAwesomeIcon>
                                </NavLink>
                            </Nav.Link>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default Header;